import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
import subscribe from './modules/subscribe'
import user from './modules/user'
import newShop from './modules/newShop'
import businessCenter from '@/views/business-center/store/index'
import ingredient from './modules/ingredient'
import coachProve from './modules/coachProve'
import betterweVip from './modules/betterwe-vip'
import drinkWater from './modules/drink-water'
import cnaV2 from './modules/cna-v2'
import nutritionClock from './modules/nutrition-clock.js'
import coachActivity2024 from './modules/coach-activity-2024.js'
import solarTerms from './modules/solarTerms'
import closeNotice from './modules/closeNotice'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: null,
    mealCardReviewUserInfo: null, // 餐卡点评系统用户信息（独立存储避免冲突）
    mealCardReviewUserInfoPromise: null, // 用户信息获取的Promise（避免重复请求）
    location: null,
    curCity: {
      // 当前城市
      region_id: '',
      cityname: '',
      shop_count: 0
    },
    curShop: null
  },
  mutations: {
    //设置用户信息
    setUserInfo(state, data) {
      state.userInfo = data
    },
    // 设置餐卡点评系统用户信息（独立存储避免冲突）
    mealCardReviewUser(state, data) {
      state.mealCardReviewUserInfo = data
    },
    // 设置餐卡点评系统用户信息获取的Promise
    setMealCardReviewUserInfoPromise(state, promise) {
      state.mealCardReviewUserInfoPromise = promise
    },
    saveLocation(state, data) {
      state.location = data
    }, // 设置当前选择的城市
    setCurCity(state, b) {
      state.curCity = b
    },
    setCurShop(state, b) {
      state.curShop = b
    }
  },
  actions: {
    /**
     * 获取餐卡点评系统用户信息
     * 如果已有用户信息，直接返回
     * 如果正在获取，返回现有的Promise
     * 否则发起请求获取用户信息
     */
    async fetchMealCardReviewUserInfo({ state, commit }) {
      // 如果已有用户信息，直接返回
      if (state.mealCardReviewUserInfo) {
        return state.mealCardReviewUserInfo
      }

      // 如果正在获取，返回现有的Promise
      if (state.mealCardReviewUserInfoPromise) {
        return state.mealCardReviewUserInfoPromise
      }

      // 检查是否有token
      const token = Cookies.get('meal-card-review-token')
      if (!token) {
        return Promise.reject(new Error('未登录'))
      }

      // 创建获取用户信息的Promise
      const promise = new Promise((resolve, reject) => {
        // 这里应该调用真实的API获取用户信息
        // 暂时使用假数据
        setTimeout(() => {
          try {
            // 从localStorage获取用户信息
            const userInfoStr = localStorage.getItem('meal_card_user_info')
            if (userInfoStr) {
              const userInfo = JSON.parse(userInfoStr)
              commit('mealCardReviewUser', userInfo)
              resolve(userInfo)
            } else {
              reject(new Error('用户信息不存在'))
            }
          } catch (error) {
            reject(error)
          } finally {
            // 清除Promise，允许重新获取
            commit('setMealCardReviewUserInfoPromise', null)
          }
        }, 100)
      })

      // 保存Promise到state，避免重复请求
      commit('setMealCardReviewUserInfoPromise', promise)

      return promise
    }
  },
  modules: {
    businessCenter,
    subscribe,
    user,
    newShop,
    ingredient,
    coachProve,
    betterweVip,
    drinkWater,
    cnaV2,
    nutritionClock,
    coachActivity2024,
    solarTerms,
    closeNotice // 闭馆通知配置
  }
})
